import { useParams } from 'react-router-dom';
import { DEVELOPER_MIMIK_URL } from '../constant/path';

const RedirectRoute = () => {
    const params = useParams();
    window.location.replace(DEVELOPER_MIMIK_URL + `${params["*"]}`);
}

export default RedirectRoute